var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-config-wrap"},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"公众号配置"}},[_c('wx-config')],1),_c('TabPane',{attrs:{"label":"系统配置"}},[_c('system-config')],1),_c('TabPane',{attrs:{"label":"模板消息配置"}},[_c('wxTemplateConfig')],1),_c('TabPane',{attrs:{"label":"水印配置"}},[_c('water-mark')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }